import api from '../../../../admin/api/api';
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store =  new Vuex.Store({
    namespaced: true,
    state: {
        userAvatar: '',
        form: {
            description: "",
            mark: null,
            anon: false,
            userId: window.laravel.userId,
            parentId: null,
            consultation: null
        },
        comment: {
            description: "",
            userId: window.laravel.userId,
            parentId: null,
        },
        error: false,
        flag: true,
        reviews: window.laravel.reviews,
        show: null
    },
    mutations: {
        setUserAvatar(state, avatar) {
            state.userAvatar = avatar;
        },
        setError(state, error) {
            state.error = error;
        },
        setFlag(state, value) {
            state.flag = value;
        },
        setReview(state, review) {
            state.reviews.unshift(review);
        },
        addComment(state, comment) {
            state.reviews.forEach((review) => {
                if (review.id === comment.parent_id) {
                    review.comments.push(comment);
                }
            });
        },
        clearArrayComment(state) {
            state.comment.description = '';
            state.comment.userId = window.laravel.userId;
            state.comment.parentId = null;
        },
        clearForm(state) {
            state.form.description = '';
            state.form.mark = null;
            state.form.anon = false;
            state.form.userId = window.laravel.userId;
            state.form.parentId = null;
            state.form.consultation = null;
        },
        setShowForm(state, value){
            state.show = value;
        }
    },
    actions: {
        postReview({commit, rootState}) {
            api.post('/api/review', rootState.form)
                .then((response) => {
                    commit('setReview', response.data);
                    commit('clearForm');
                }).catch(error => {
                    commit('setError', true);
            });
            commit('setFlag',false);
        },
        postComment({commit, rootState}) {
            api.post('/api/make-comment', rootState.comment)
                .then((response) => {
                    commit('addComment', response.data);
                    commit('setShowForm', null);
                    commit('clearArrayComment');
                }).catch(error => {
                });
        },
    }
});
